<template>
  <div id="pest-analyse" style="overflow:hidden; width: 100%; height: 100%">
    <div v-if="pestLoadFlg" style="left: 50%; top: 50%; position:absolute; color: #5BF2FF">
      <dv-loading>Loading....</dv-loading>
    </div>
    <div class="pestAnalyse-data">
      <div class="pestAnalyse-data-head">
        <div class="pestAnalyse-head-title">
          <span class="pestAnalyse-head-title-container">虫情图片分析</span>
        </div>

        <div class="pestAnalyse-head-select">
          <div class="pestAnalyse-select-device">
            <el-select @change="pestDeviceChange($event)" v-model="defaultPestDevice" filterable>
              <el-option :key="item.deviceAddr" :label="item.deviceName" :value="item.deviceAddr" v-for="item in pestDeviceList"></el-option>
            </el-select>
          </div>

          <div class="pestAnalyse-select-time" >
            <el-date-picker @change="pestSelectTime" v-model="defaultPestTime" unlink-panels type="datetimerange" :picker-options="pestPickerOptions" align="right"
                            end-placeholder="结束日期" key="time" range-separator="至" start-placeholder="开始日期">
            </el-date-picker>
          </div>

          <div class="pestAnalyse-select-btn">
            <el-button type="primary" @click="pestQueryData()">查询</el-button>
          </div>
        </div>
      </div>
      <div class="pestAnalyse-data-content" style="overflow: auto;">
        <div v-for="(row, index) in sliceList(pestPicLists.slice((pestCurrentPage-1)*4,pestCurrentPage*4), 2)":key="index"  class="pestAnalyse-data-main">
          <div class="pestAnalyse-content-container">
            <div v-for="(item, i) in row" class="pestAnalyse-content-item">
              <div class="pestAnalyse-item-img">
                <img :src= "item.targetUrl"  @click="openModal(item.targetUrl, item.imageUrl)"  @error="e => {e.target.src = item.imageUrl}" class="pestAnalyse-item-imgValue" referrerpolicy="no-referrer"/>
              </div>
              <div class="pestAnalyse-item-main">
                <div class="pestAnalyse-item-name">
                  <span class="pestAnalyse-item-value">设备ID：{{item.deviceId}}</span>
                </div>
                <div class="pestAnalyse-item-name">
                  <span class="pestAnalyse-item-value">图像ID：{{item.imgId}}</span>
                </div>
                <div class="pestAnalyse-item-name">
                  <span  class="pestAnalyse-item-value">创建时间：{{item.createTime}}</span>
                </div>
                <div class="pestAnalyse-item-result">
                  <span>分析结果：<br/>&#12288{{item.analyseData}}</span>
                </div>
              </div>
            </div>
            <div v-if="showModal" class="pest-modal" @click="closeModal">
              <div class="pest-modal-content">
                <img :src="selectedImage" alt="放大的图片" class="pest-enlarged-image" />
              </div>
            </div>
          </div>
        </div>
        <el-pagination @current-change="pestCurrentChange" :current-page="pestCurrentPage" class="pestAnalyse-data-bottom"
                       :page-size="4" layout="total, prev, pager, next, jumper" :total="pestPicLists.length">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import {getWormDataList} from "../../until/api/SporePest";
  import {insectAnalyse, insectDevice} from "../../until/api/inesctPest";
  export default {
    name: 'PestAnalyseData',
    components: {},
    computed: {
      sliceList() {
        return function (data,count) {
          if(data != undefined) {
            let index = 0;
            let arrTemp = [];
            for(let i = 0; i < data.length; i++) {
              index = parseInt(i / count);
              if(arrTemp.length <= index) {
                arrTemp.push([])
              }
              arrTemp[index].push(data[i]);
            }
            return arrTemp;
          }
        }
      }
    },
    data() {
      return {
        pestDeviceList:[],
        defaultPestDevice:'',
        defaultPestTime: [moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")],
        pestPickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        beginTime: '',
        endTime: '',
        pestPicLists: [],
        pestCurrentPage: 1,
        showModal: false, // 控制模态框的显示
        selectedImage: null, // 存储点击的图片URL
        pestLoadFlg: false
      }
    },

    mounted() {
      this.beginTime = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"); //初期化开始时间
      this.endTime = moment().format("YYYY-MM-DD HH:mm:ss"); //初期化结束时间
      //获取用户等级
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;
      if(authority != 'TENANT_ADMIN') {
        this.getWornDevice(customerId); //获取虫情设备
      }
    },
    methods: {
      /**
       * 获取虫情设备
       * @param customerId
       */
      getWornDevice(customerId) {

        let token = this.$commonFun.unCompileStr(localStorage.getItem('insectToken'));
        insectDevice(token).then(response => {
          if(response.data.code == 0) {
            for(let i = 0; i < response.data.data.length; i++) {
              this.pestDeviceList.push({"deviceAddr": response.data.data[i].imei, "deviceName": response.data.data[i].devName})
            }
            if(this.pestDeviceList.length > 0) {
              this.defaultPestDevice = this.pestDeviceList[0].deviceAddr;
              this.pestDeviceData();
            }
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      /**
       * 切换虫情设备
       * @param event
       */
      pestDeviceChange(event) {
        this.defaultPestDevice = event;
        this.pestPicLists = [];
      },

      /**
       * 获取选中的时间
       * @param val
       */
      pestSelectTime(val) {
        if(val === null) {//清空日期
          this.defaultPestTime = [moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]; //默认时间
          this.beginTime = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"); //默认开始时间
          this.endTime = moment().format("YYYY-MM-DD  HH:mm:ss"); //默认结束时间
        } else {//非清空数据
          this.beginTime = moment(new Date(val[0]).getTime()).format("YYYY-MM-DD HH:mm:ss"); //开始时间
          this.endTime = moment(new Date(val[1]).getTime()).format("YYYY-MM-DD HH:mm:ss");//结束时间
        }
      },

      /**
       * 查询按钮
       */
      pestQueryData() {
        if(this.defaultPestDevice != '') { //虫情设备存在
          this.pestDeviceData(); //查询虫情历史数据
        }
      },

      /**
       * 获取虫情历史数据
       */
      async pestDeviceData() {
        this.pestPicLists = [];
        this.pestCurrentPage = 1;
        this.pestLoadFlg = true;
        try {
          let token = this.$commonFun.unCompileStr(localStorage.getItem('insectToken'));
          let response = await insectAnalyse(this.beginTime, this.endTime, this.defaultPestDevice, token);
          if(response.data.data.length == 0) {
            this.pestLoadFlg = false;
            this.$message({
              showClose: true,
              type: 'warning',
              message: '所选的时间段内未查询出数据'
            })
            return;
          }
          if (response.data.code === 0) {
            this.pestLoadFlg = false;
            let promises = [];  // 创建 promises 数组，用于收集异步操作

            for (let i = response.data.data.length - 1; i >= 0; i--) {

              // 生成数据并推入 pestPicLists 数组
              let json = {
                deviceId: response.data.data[i].id,
                imgId: response.data.data[i].imeinum,
                createTime: response.data.data[i].createTime,
                imageUrl: response.data.data[i].image,
                targetUrl: response.data.data[i].plotimage,
                analyseData: ''  // 初始化 analyseData
              };

              this.pestPicLists.push(json);

              // 将 pestImgData 调用加入 promises 数组，并确保 i 的索引正确
              promises.push(this.pestImgData(this.pestPicLists.length - 1, response.data.data[i].detectResoult));
            }

            // 等待所有 pestImgData 的调用完成
            await Promise.all(promises);
          } else {
            this.pestLoadFlg = false;
          }
        } catch (error) {
          this.pestLoadFlg = false;
          console.log("error", error);
        }
      },

      /**
       * 根据imgId获取图片分析后图片
       * @param i
       * @param imgId
       */
      async pestImgData(i, detectResoult) {
        // 确保索引 i 有效
        if (i >= 0 && i < this.pestPicLists.length) {
          if (detectResoult == undefined || JSON.parse(detectResoult) == "[]") {
            this.pestPicLists[i].analyseData = '未分析';
          } else {
            let obj = {};
            try {
              let jsonObject = JSON.parse(JSON.parse(detectResoult));  // 解析数据
              jsonObject.forEach(v => obj[v.name] = obj[v.name] === undefined ? 1 : obj[v.name] + 1);

              // 拼接分析结果字符串
              let str = "";
              for (let o in obj) {
                str += `${o}:${obj[o]}；`;
              }
              this.pestPicLists[i].analyseData = str;
            } catch (e) {
              console.error("Error parsing detectResoult:", e);
              this.pestPicLists[i].analyseData = '解析错误';
            }
          }
        } else {
          console.error("Invalid index:", i);  // 防止无效索引
        }
      },

      /**
       * 切换页数
       * @param currentPage
       */
      pestCurrentChange(currentPage) {
        this.pestCurrentPage = currentPage;
      },

      openModal(targetUrl, fallbackUrl) {
        const image = new Image();
        image.src = targetUrl;

        image.onload = () => {
          this.selectedImage = targetUrl; // targetUrl 加载成功
        };
        image.onerror = () => {
          this.selectedImage = fallbackUrl; // targetUrl 加载失败，使用 fallbackUrl
        };

        this.showModal = true; // 显示模态框
      },

      closeModal() {
        this.showModal = false; // 关闭模态框
        this.selectedImage = null; // 清除图片URL
      },
    }
  }
</script>

<style lang="less">
  @import "../less/PestAnalyseData";
</style>

<style>
  .pestAnalyse-data-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/PestAnalyseData.vue